export default __webpack_public_path__ + "static/pub-circle-82a97519634fe26e9dad57776a5474c6.png";